import { useEffect, useState } from 'react';

/*
 * How the person travels to a target: 'car2' (4x2 + walk), 'car4' (4x4 +
 * walk) or 'walk'. One choice for the map and the camera, kept on the
 * device; a change in one tab is announced to the same tab's other screens
 * ('pitriot:route-mode'), as utils/activeTarget.js does.
 */
const KEY = 'mb_route_mode';
const EVENT = 'pitriot:route-mode';
export const TRAVEL_MODES = ['car2', 'car4', 'walk'];
export const DEFAULT_MODE = 'car2';

export function readTravelMode(storage = globalThis.localStorage) {
  try {
    const value = storage?.getItem(KEY);
    return TRAVEL_MODES.includes(value) ? value : DEFAULT_MODE;
  } catch (e) {
    return DEFAULT_MODE;
  }
}

export function setTravelMode(mode, storage = globalThis.localStorage) {
  if (!TRAVEL_MODES.includes(mode)) return;
  try { storage?.setItem(KEY, mode); } catch (e) { /* kept for this page only */ }
  if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent(EVENT, { detail: mode }));
}

export function useTravelMode() {
  const [mode, setMode] = useState(readTravelMode);
  useEffect(() => {
    const onChange = (e) => setMode(TRAVEL_MODES.includes(e?.detail) ? e.detail : readTravelMode());
    const onStorage = (e) => { if (!e || e.key === KEY) setMode(readTravelMode()); };
    window.addEventListener(EVENT, onChange);
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener(EVENT, onChange);
      window.removeEventListener('storage', onStorage);
    };
  }, []);
  return [mode, setTravelMode];
}
